/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2020-12-25 18:03:42
 */
//用户id
export function setuser_id(user_id) {
    window.localStorage.setItem('user_id', user_id)
}

export function getuser_id() {
    return window.localStorage.getItem('user_id')
}

//组id
export function setgroup(group) {
    window.localStorage.setItem('group', group)
}

export function getgroup() {
    return window.localStorage.getItem('group')
}

//客户id
export function setclient_user_id(client_user_id) {
    window.localStorage.setItem('client_user_id', client_user_id)
}

export function getclient_user_id() {
    return window.localStorage.getItem('client_user_id')
}

//角色id
export function setroleId(roleId) {
    window.localStorage.setItem('roleId', roleId)
}

export function getroleId() {
    return window.localStorage.getItem('roleId')
}

//跟nct_customer表关联的ID
export function setuser_ctid(user_ctid) {
    window.localStorage.setItem('user_ctid', user_ctid)
}

export function getuser_ctid() {
    return window.localStorage.getItem('user_ctid')
}

//存储用户标识
export function setuser_iscustomer(user_iscustomer) {
    window.localStorage.setItem('user_iscustomer', user_iscustomer)
}
//获取用户标识
export function getuser_iscustomer() {
    return window.localStorage.getItem('user_iscustomer')
}
//存储当前默认语言
export function SetLan(Lan) {
    window.localStorage.setItem('I18n',Lan)
}
//获取当前默认语言
export function GetLan() {
    return window.localStorage.getItem('I18n')
}
//存储当前登录账户默认分组
export function setdefaultGroupId(defaultGroupId) {
    window.localStorage.setItem('defaultGroupId', defaultGroupId)
}
//获取当前登录账户默认分组
export function getdefaultGroupId() {
    return window.localStorage.getItem('defaultGroupId')
}

// 存储地图的选择
export function SetMapType(map) {
  window.localStorage.setItem('mapType', map)
}
// 获取当前登录账户默认地图
export function GetMapType() {
  return window.localStorage.getItem('mapType')
}


// 存储当前用户是否开启云监测功能
export function SetMonitor(status) {
  window.localStorage.setItem('monState', status)
}
// 获取当前用户是否开启云监测功能
export function GetMonitor() {
  return window.localStorage.getItem('monState')
}